import request from '../utils/request';
import tokenRequest from '../utils/tokenRequest';
const auth = {
  /**
   * 用户登陆，token获取等
   * */
  login: (data) => {
    return request({
      url: '/main/login',
      method: 'post',
      data: data,
    });
  },
  /**
   * 校验token是否过期
   */
  tokenPass: (data) => {
    return tokenRequest({
      url: '/main/getCaptchaOpen',
      method: 'get',
    });
  },
  /**
 * 退出登录
 */
  loginOut: (data) => {
    return tokenRequest({
      url: "/main/logout",
      method: 'get',
    })
  },

  // 外链跳转 sessionld 获取token
  outLinkGetToken: (data) => {
    return request({
      url: "/main/oauth/getToken",
      method: 'get',
      params: data
    })
  },

  /**
   * role角色管理模块开始
   * **/
  // 获取角色列表
  getRolePage: (data) => {
    return tokenRequest({
      url: '/main/sysRole/page',
      method: 'get',
      params: data,
    });
  },
  // 新增角色
  addRole: (data) => {
    return tokenRequest({
      url: '/main/sysRole/add',
      method: 'post',
      data: data,
    });
  },
  // 编辑角色
  editRole: (data) => {
    return tokenRequest({
      url: '/main/sysRole/edit',
      method: 'post',
      data: data,
    });
  },
  // 删除角色
  deleteRole: (data) => {
    return tokenRequest({
      url: '/main/sysRole/delete',
      method: 'post',
      data: data,
    });
  },
  // 获取所有菜单树
  getSysMenuTree: () => {
    return tokenRequest({
      url: '/main/sysMenu/treeForGrant',
      method: 'get',
    });
  },
  // 获取当前角色已经拥有菜单树
  getOwnMenuTree: (data) => {
    return tokenRequest({
      url: '/main/sysRole/ownMenu',
      method: 'get',
      params: data,
    });
  },
  // 获取所有机构树
  getSysOrgTree: () => {
    return tokenRequest({
      url: '/main/sysOrg/tree',
      method: 'get',
    });
  },
  /**
   * 获取组织机构和所有子组织机构信息
   * @param  data  id 查自己 pid 是查他下级
   * @returns 
   */
  getTreeWithPid: (data) => {
    return tokenRequest({
      url: 'main/sysOrg/treeWithPid',
      method: 'get',
      params: data,
    });
  },
  /**
   * 获取组织机构和子组织机构信息(分页)
   * @param  data  id 查自己 pid 是查他下级
   * @returns 
   */
  getSysOrgPage: (data) => {
    return tokenRequest({
      url: '/main/sysOrg/page',
      method: 'get',
      params: data,
    });
  },
  /**
   * 获取组织机构和子组织机构信息（不分页）
   * @param  data  id 查自己 pid 是查他下级
   * @returns 
   */
  getSysOrgList: (data) => {
    return tokenRequest({
      url: '/main/sysOrg/list',
      method: 'get',
      params: data,
    });
  },
  // 获取当前角色已经拥有菜单树
  getOwnOrgTree: (data) => {
    return tokenRequest({
      url: '/main/sysRole/ownData',
      method: 'get',
      params: data,
    });
  },
  // 授权菜单
  setSysMenuTree: (data) => {
    return tokenRequest({
      url: '/main/sysRole/grantMenu',
      method: 'post',
      data: data,
    });
  },
  // 数据范围
  getDropDown: (data) => {
    return tokenRequest({
      url: '/main/sysDictType/dropDown',
      method: 'get',
      params: data,
    });
  },
  // 授权权限
  setSysOrgTree: (data) => {
    return tokenRequest({
      url: '/main/sysRole/grantData',
      method: 'post',
      data: data,
    });
  },
  /**
   * role角色管理模块结束
   * **/
  /**
   * account账号管理模块开始
   * **/
  // 获取账号列表
  getAccountPage: (data) => {
    return tokenRequest({
      url: '/main/sysUser/page',
      method: 'get',
      params: data,
    });
  },
  // 职位下拉
  getPosIdList: (data) => {
    return tokenRequest({
      url: '/main/sysPos/list',
      method: 'get',
      params: data,
    });
  },
  // 获取当前账号已经拥有权限树
  getUserOwnOrgTree: (data) => {
    return tokenRequest({
      url: '/main/sysUser/ownData',
      method: 'get',
      params: data,
    });
  },
  // 新增用户
  addUser: (data) => {
    return tokenRequest({
      url: '/main/sysUser/add',
      method: 'post',
      data: data,
    });
  },
  // 用户信息详情
  detailUser: (data) => {
    return tokenRequest({
      url: '/main/sysUser/detail',
      method: 'get',
      params: data,
    });
  },
  // 编辑用户
  editUser: (data) => {
    return tokenRequest({
      url: '/main/sysUser/edit',
      method: 'post',
      data: data,
    });
  },
  // 重置密码
  resetPassword: (data) => {
    return tokenRequest({
      url: '/main/sysUser/resetPwd',
      method: 'post',
      data: data,
    });
  },
  // 修改密码
  updatePassword: (data) => {
    return tokenRequest({
      url: '/main/sysUser/updatePwd',
      method: 'post',
      data: data,
    });
  },
  // 删除用户
  deleteUser: (data) => {
    return tokenRequest({
      url: '/main/sysUser/delete',
      method: 'post',
      data: data,
    });
  },
  // 根据orgId获取orgname
  getOrgList: (data) => {
    return tokenRequest({
      url: '/main/sysOrg/list',
      method: 'get',
      params: data,
    });
  },
  // 授权数据
  setSysUserTree: (data) => {
    return tokenRequest({
      url: '/main/sysUser/grantData',
      method: 'post',
      data: data,
    });
  },
  // 重置密码
  sysUserResetPwd(data) {
    return tokenRequest({
      url: '/main/sysUser/resetPwd',
      method: 'post',
      data: data,
    });
  },
  // 授权角色列表
  sysUserOwnRole(data) {
    return tokenRequest({
      url: '/main/sysUser/ownRole',
      method: 'get',
      params: data,
    });
  },
  // 确定授权
  setSysRoleTree(data) {
    return tokenRequest({
      url: '/main/sysUser/grantRole',
      method: 'POST',
      data: data,
    });
  },
  /**
   * account账号管理模块结束
   * **/
  /**
   * org机构管理模块开始  getAccountPage
   * **/
  // 获取机构列表
  getOrgPage: (data) => {
    return tokenRequest({
      url: '/main/sysOrg/page',
      method: 'get',
      params: data,
    });
  },
  // 新增组织
  addOrg: (data) => {
    return tokenRequest({
      url: '/main/sysOrg/add',
      method: 'POST',
      data: data,
    });
  },
  // 新增组织
  addOrgWithPark: (data) => {
    return tokenRequest({
      url: '/main/sysOrg/addWithPark',
      method: 'POST',
      data: data,
    });
  },
  // 编辑组织
  editOrg: (data) => {
    return tokenRequest({
      // url: '/main/sysOrg/edit',
      url: '/main/sysOrg/editWithPark',
      method: 'POST',
      data: data,
    });
  },
  // 删除组织
  deleteOrg: (data) => {
    return tokenRequest({
      url: '/main/sysOrg/delete',
      method: 'POST',
      data: data,
    });
  },
  /***
   *
   * 获取登陆用户信息
   * **/
  getUserInfo: (data) => {
    return tokenRequest({
      url: '/main/getLoginUser',
      method: 'get',
      params: data,
    });
  },
  /**
   * 菜单管理
   * */
  getMenuList: (data) => {
    return tokenRequest({
      url: '/main/sysMenu/list',
      method: 'get',
      params: data,
    });
  },
  // 菜单列表
  getMenuTreeList: (data) => {
    return tokenRequest({
      url: "/main/sysMenu/tree",
      method: 'get',
      params: data
    })
  },
  // 新增菜单
  addMenuList: (data) => {
    return tokenRequest({
      url: "/main/sysMenu/add",
      method: 'post',
      data
    })
  },
  // 删除菜单
  deleteMenuList: (data) => {
    return tokenRequest({
      url: "/main/sysMenu/delete",
      method: 'post',
      data
    })
  },
  // 查看菜单
  detailMenuList: (data) => {
    return tokenRequest({
      url: "/main/sysMenu/detail",
      method: 'post',
      data
    })
  },
  // 编辑菜单
  editMenuList: (data) => {
    return tokenRequest({
      url: "/main/sysMenu/edit",
      method: 'post',
      data
    })
  },
  // 系统应用列表
  getAppList: (data) => {
    return tokenRequest({
      url: "/main/sysApp/list",
      method: 'get',
      params: data
    })
  },
  // 获取用户可切换的组织
  getUserOrganizationList: (data) => {
    return tokenRequest({
      url: "/main/sysOrg/treeWithoutParent",
      method: "get",
      params: data,
    });
  },

  // 获取用户可切换的组织园区
  getUserOrgAndParkList: (data) => {
    return tokenRequest({
      url: "/main/sysOrg/treeWithPark",
      method: "get",
      params: data,
    });
  },
  // 获取园区列表
  getParkList: (data) => {
    return tokenRequest({
      url: "/main/sysPark/list",
      method: "get",
      params: data,
    });
  },
  // 同步组织数据
  sendOrgData: (data) => {
    return tokenRequest({
      url: "/main/sysOrg/sendOrgData",
      method: "post",
      data: data
    });
  },
  // 根据组织id获取组织信息
  getOrgDetailByOrgId: (data) => {
    return tokenRequest({
      url: "/main/sysOrg/detailWithPark",
      method: "get",
      params: data
    });
  },
};

export default auth;
